import { WorkflowTemplateStatus } from '../Types'

const product: WorkflowTemplateStatus = {
  configuration: {
    '20ca8858-9036-4dc7-8751-b67cfa1b6838': {
      exit: [],
      entry: [],
    },
    '937b1118-13fc-47aa-9062-455660820d2d': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'reviews.create',
          config: {},
        },
      ],
    },
    '8d0896c0-e019-43de-8218-8498a09018f5': {
      exit: [],
      entry: [],
    },
    '7035ed9f-1801-4c21-91cd-51f82d0ec5d0': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'approvals.create',
          config: {},
        },
      ],
    },
    '3dc7afb8-b695-42d0-86d2-27a968a73c8e': {
      exit: [],
      entry: [],
    },
    '0314ac92-95c2-47a6-9701-495390ed0515': {
      exit: [],
      entry: [],
    },
    '2cb50ae7-3743-437c-9deb-a01ef0637fea': {
      exit: [],
      entry: [],
    },
  },
  property_values: [
    {
      uuid: '20ca8858-9036-4dc7-8751-b67cfa1b6838',
      value: 'Draft',
      meta: {
        color: '#E5ECF3',
      },
      position: 0,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '937b1118-13fc-47aa-9062-455660820d2d',
      value: 'Team Review',
      meta: {
        color: '#EBDCFF',
      },
      position: 1,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '8d0896c0-e019-43de-8218-8498a09018f5',
      value: 'Team Reviewed',
      meta: {
        color: '#8626FF',
      },
      position: 2,
      connected_to_uuid: '937b1118-13fc-47aa-9062-455660820d2d',
      connected_to_id: null,
    },
    {
      uuid: '7035ed9f-1801-4c21-91cd-51f82d0ec5d0',
      value: 'Leadership Approval',
      meta: {
        color: '#FFD6F9',
      },
      position: 3,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '2cb50ae7-3743-437c-9deb-a01ef0637fea',
      value: 'Leadership Approved',
      meta: {
        color: '#E43CD5',
      },
      position: 4,
      connected_to_uuid: '7035ed9f-1801-4c21-91cd-51f82d0ec5d0',
      connected_to_id: null,
    },
    {
      uuid: '3dc7afb8-b695-42d0-86d2-27a968a73c8e',
      value: 'Final',
      meta: {
        color: '#028C3A',
      },
      position: 5,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '0314ac92-95c2-47a6-9701-495390ed0515',
      value: 'Deprecated',
      meta: {
        color: '#FFCBCB',
      },
      position: 6,
      connected_to_uuid: null,
      connected_to_id: null,
    },
  ],
}

export default product
